(function () {
	function updateCardPin(sectionEl) {
		if (window.innerWidth < 990) return;

		const markersEl = sectionEl.querySelector('.product-markers__markers');
		if (!markersEl) return;

		markersEl.querySelectorAll('.product-markers__item-inner').forEach(c => c.style.removeProperty('top'));

		const card = markersEl.querySelector('.product-markers__item-inner.active');
		if (!card) {
			sectionEl.classList.remove('card-pinned');
			return;
		}

		const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
		const offset = 2.4 * rem;
		const mRect = markersEl.getBoundingClientRect();
		const vh = window.innerHeight;
		const cardH = card.offsetHeight;

		if (mRect.top > vh || mRect.bottom < 0) {
			sectionEl.classList.remove('card-pinned');
			return;
		}


		const settleThreshold = vh - 2 * offset - cardH;


		let cardTop;
		if (mRect.top > settleThreshold) {
			// Tracking: card follows image top as section enters viewport
			cardTop = mRect.top + offset;
		} else if (mRect.bottom >= vh) {
			// Settled: card fixed at viewport bottom-left
			cardTop = vh - offset - cardH;
		} else {
			// Exiting: card follows image bottom as section scrolls away
			cardTop = mRect.bottom - offset - cardH;
		}

		sectionEl.classList.add('card-pinned');
		card.style.top = `${cardTop}px`;
	}

	const productMarkers = (section) => {
		let parent = document.currentScript
			? document.currentScript.parentElement
			: section;

		let productsSelector = "";
		let markersSelector = ".js-product-markers__item";
		if (window.innerWidth >= 990) {
			productsSelector = ".product-markers__markers .product-markers__item-inner";
		} else {
			productsSelector = ".product-markers-for-mobile .product-markers__item-inner";
		}

		var products = parent?.querySelectorAll(productsSelector);
		var markers = parent?.querySelectorAll(markersSelector);

		if (parent) {
			markers.forEach((item) => {
				item.addEventListener("click", (event) => {
					event.stopPropagation();
					const index = item.dataset.index;
					item.classList.toggle("active");

					let otherMarkers = [...markers].filter(marker => marker !== item);
					let product = parent?.querySelector(
						`${productsSelector}[data-index="${index}"]`
					);
					let otherProducts = parent?.querySelectorAll(
						`${productsSelector}:not([data-index="${index}"])`
					);

					product?.classList.toggle("active");
					otherProducts.forEach(elem => elem.classList.remove("active"));
					otherMarkers.forEach(marker => marker.classList.remove("active"));

					if (window.innerWidth >= 990) {
						parent
						.querySelector(".product-markers__markers")
						.classList.add("active");
					} else {
						parent
						.querySelector(".product-markers-for-mobile")
						.classList.add("active");
					}

					const sectionEl = parent.querySelector('.product-markers-section') || parent.closest('.product-markers-section');
					if (sectionEl) updateCardPin(sectionEl);
				});
			});

			parent.querySelector(markersSelector).click();
		}

		document.addEventListener("click", (e) => {
			if (!(e.target instanceof Element)) return;
			const parentClicked = e.target.closest(markersSelector);
			markers?.forEach((marker) => {
				if (parentClicked !== marker && !e.target.closest(productsSelector)) {
					marker.classList.remove("active");
					products?.forEach(product => product.classList.remove("active"));
				}
			});
		});
	};

	productMarkers();

	document.addEventListener("DOMContentLoaded", function () {
		document.addEventListener("shopify:section:load", function (section) {
			productMarkers(section.target);
		});
	});

	if ('IntersectionObserver' in window) {
		const stickyObs = new IntersectionObserver(
			(entries) => {
				entries.forEach(entry => {
					entry.target.classList.toggle('is-in-viewport', entry.isIntersecting);
					if (entry.isIntersecting) {
						updateCardPin(entry.target);
					} else {
						const markersEl = entry.target.querySelector('.product-markers__markers');
						if (markersEl) markersEl.querySelectorAll('.product-markers__item-inner').forEach(c => c.style.removeProperty('top'));
						entry.target.classList.remove('card-pinned');
					}
				});
			},
			{ threshold: 0 }
		);

		document.querySelectorAll('.product-markers-section').forEach(section => stickyObs.observe(section));

		document.addEventListener('scroll', () => {
			document.querySelectorAll('.product-markers-section.is-in-viewport').forEach(updateCardPin);
		}, { passive: true });

		document.addEventListener('shopify:section:load', ({ target }) => {
			const section = target.querySelector('.product-markers-section');
			if (section) stickyObs.observe(section);
		});

		document.addEventListener('shopify:section:unload', ({ target }) => {
			const section = target.querySelector('.product-markers-section');
			if (section) stickyObs.unobserve(section);
		});
	}
})();
